/*
 * The Case IDE pane's live sync: `useAgentThreadLive` under the `"case-ide"`
 * owner so it shares the tab's event stream with the agent panel.
 */
import type { AgentChat } from "@/features/agents/useAgentChat";
import { useAgentThreadLive } from "@/features/agents/useAgentThreadLive";

export { FALLBACK_POLL_MS } from "@/features/agents/useAgentThreadLive";

export const CASE_IDE_REALTIME_OWNER = "case-ide";

export const useThreadLive = (chat: AgentChat): void =>
  useAgentThreadLive(CASE_IDE_REALTIME_OWNER, chat);
